const removeEmptyElement = (elems) => {
    [...elems].forEach(item => {
        if (item.innerHTML.trim().length == 0) {
            item.remove();
        }
    });
}

export {
    removeEmptyElement
}
